export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14038.4f9309eb.jpg";